import { useBatchedSimpleUser } from "@/-dataloaders/simple-users"
import { useTranslation } from "react-i18next"

interface Props {
  userId: number
}

export function PersonNameWithUserNameFallback({ userId }: Props) {
  const { t } = useTranslation("app_server")
  const { data: user } = useBatchedSimpleUser(userId)
  if (!user) return ""
  if (!user.personId && !user.isUserGroup)
    return user.userName + " (" + t("NoContact") + ")"

  return user.userName
}
